import { DirectoryUpdateRecordParam } from 'api/requests';
import { DirectorySchemaData } from 'api/types/data/directory/directory';
import { parseDirectoryRecordFieldParam } from 'modules/directory/common/helpers';

export const getUpdateSubmitData = (
  currentSchema: DirectorySchemaData,
  values: {}
): DirectoryUpdateRecordParam => ({
  fields: parseDirectoryRecordFieldParam(currentSchema, values),
});
